import graphql__a72677dae87a40bbb667 from "./__generated__/ContributionsDatavizRootLayout_participativeModule.graphql.js";import { graphql, useFragment } from "react-relay";
import { defineMessages } from "react-intl";
import classNames from "classnames";

import { useUniqueId } from "../../../Utils/uniqueId";
import { useFormatMessage } from "../../../Intl/Context";
import { isUnauthorized } from "../../../Utils/authorizations";
import { getContributionsAnchorId } from "../../../Utils/anchorIds";
import AnchorTarget from "../../../Utils/AnchorTarget";
import ContributionsDatavizTabs from "./ContributionsDatavizTabs";
import ContributionsDatavizThemesNavigation from "./ContributionsDatavizThemesNavigation";
import ContributionsDatavizMainContainerHeader from "./ContributionsDatavizMainContainerHeader";

const ContributionsDatavizRootLayout = props => {
  const participativeModule = useFragment(
    ContributionsDatavizRootLayout_participativeModule,
    props.participativeModule
  );
  const { contributionsCount } = participativeModule;
  const { contributionsDisplayAuthorized } = participativeModule.authorizations;
  const { children, graphViewActive, listViewActive } = props;

  const contributionDatavizRootTitleId = useUniqueId("contribution-dataviz-root-layout");

  const t = useFormatMessage();
  const contributionsCountLabel = t(intlMessages.contributionsCount, {
    count: contributionsCount
  });

  if (isUnauthorized(contributionsDisplayAuthorized)) return null;

  const className = classNames("participative-datavisualization-container", "container", {
    "participative-datavisualization-graph-root": graphViewActive,
    "participative-datavisualization-list-root": listViewActive
  });
  const contributionsAnchorId = getContributionsAnchorId(participativeModule.slug);

  return (
    <div className={className}>
      <AnchorTarget id={contributionsAnchorId} />

      <ContributionsDatavizTabs
        participativeModule={participativeModule}
        exploreTabActive={true}
      />

      <div className="row">
        <ContributionsDatavizThemesNavigation
          participativeModule={participativeModule}
          graphViewActive={graphViewActive}
          listViewActive={listViewActive}
          contributionDatavizRootTitleId={contributionDatavizRootTitleId}
        />

        <section className="col-lg-8 order-0 order-lg-1">
          <ContributionsDatavizMainContainerHeader
            participativeModule={participativeModule}
            graphViewActive={graphViewActive}
            listViewActive={listViewActive}
            contributionDatavizRootTitleId={contributionDatavizRootTitleId}
          >
            <span className="text-title-section">
              <span className="text-primary margin-right-xxs">{contributionsCount}</span>
              {contributionsCountLabel}
            </span>
          </ContributionsDatavizMainContainerHeader>

          {children}
        </section>
      </div>
    </div>
  );
};

const ContributionsDatavizRootLayout_participativeModule = graphql__a72677dae87a40bbb667;

export default ContributionsDatavizRootLayout;

export const intlMessages = defineMessages({
  contributionsCount: {
    id: "contributions.dataviz.contributionsCount",
    defaultMessage: "{count, plural, one {contribution} other {contributions}}"
  }
});
